import styles from './NotificationDetails.module.css'
import { React } from 'react'
import { IFButton, IFText } from 'Components'
import { Colors } from 'Theme'
import { useTranslation } from 'react-i18next'
import InfinityEnums from 'Enums/InfinityEnums'
import PropTypes from 'prop-types'
import { formatDate } from '../../Utils/StringFunctions'
import { Actions, Subjects } from 'Enums/permissionKeys'

const NotificationDetails = ({ row, editingAdminRole, onEdit }) => {
  const { t } = useTranslation()
  const canEditNotification = editingAdminRole?.can(
    Actions.EDIT,
    Subjects.NOTIFICATIONS,
  )

  const NotificationDetailsItems = [
    {
      key: 'englishTitle',
      value: row?.original?.title?.en || '-',
      translationKey: 'NotificationDetails.EnglishTitle',
    },
    {
      key: 'arabicTitle',
      value: row?.original?.title?.ar || '-',
      translationKey: 'NotificationDetails.ArabicTitle',
    },
    {
      key: 'englishBody',
      value: row?.original?.message?.en ? row?.original?.message?.en : '-',
      translationKey: 'NotificationDetails.EnglishMessage',
    },
    {
      key: 'arabichBody',
      value: row?.original?.message?.ar ? row?.original?.message?.ar : '-',
      translationKey: 'NotificationDetails.ArabicBody',
    },
    {
      key: 'url',
      value: row?.original?.redirectUrl || '-',
      translationKey: 'NotificationDetails.Url',
    },
    {
      key: 'groups',
      value:
        row?.original?.notificationGroups?.length > 0
          ? row.original.notificationGroups.join(', ')
          : '-',
      translationKey: 'NotificationDetails.Groups',
    },
    {
      key: 'createdAt',
      value: formatDate(row?.original?.createdAt) || '-',
      translationKey: 'NotificationDetails.CreatedAt',
    },
    {
      key: 'scheduledAt',
      value: formatDate(row?.original?.scheduledAt) || '-',
      translationKey: 'NotificationDetails.ScheduledAt',
    },
  ]

  return (
    <div
      className={styles.NotificationDetails}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.Line}>
        <div
          style={{ borderLeft: `1px solid ${Colors.DividerColor}` }}
          className={styles.Divider}
        />
        <div
          style={{ background: Colors.DividerColor }}
          className={styles.Circle}
        />
      </div>
      <div className={styles.Details}>
        <div className={styles.NotificationsDetailsPanel}>
          <IFText className={styles.NotificationTitle}>
            {t('NotificationDetails.Title')}
          </IFText>
          <div className={styles.AllDetails}>
            {NotificationDetailsItems.map((item) => (
              <div className={styles.Detail} key={item.key}>
                <div className={styles.LabelTitle}>
                  <IFText
                    className={styles.DetailText}
                    style={{ color: Colors.DetailPanel }}
                  >
                    {t(item.translationKey)}
                  </IFText>
                </div>
                <div className={styles.LabelValue}>
                  <IFText className={styles.DetailText}>{item.value}</IFText>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {canEditNotification &&
        row?.original?.status ===
          InfinityEnums.NotificationStatus.SCHEDULED && (
          <div className={styles.ButtonContainer}>
            <IFButton
              color={Colors.primary}
              size="sm"
              text={t('PushNotificationsPanel.editButton')}
              isLoading={false}
              isFill={false}
              onClick={onEdit}
              className={styles.EditButton}
            />
          </div>
        )}
    </div>
  )
}

NotificationDetails.propTypes = {
  row: PropTypes.object,
  editingAdminRole: PropTypes.object,
  onEdit: PropTypes.func,
}

export default NotificationDetails
